import React from "react";
import moment from "moment";
import { component_tool } from '@/tool'

let { WizDataTable, WizButton ,WizPopover,WizDivider} = component_tool
import { WizTableForm } from "../../../../common";
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

export const readRecordColumns =(self) => {
  let columns = []
  columns = columns.concat([
    {
      title: "账号",
      name: "userName",
      searchItem: {},
      tableItem: {}
    },
    {
      title: "姓名",
      name: "fullName",
      searchItem: {},
      tableItem: {}
    },
    {
      title: '岗位',
      name: 'positionIds',
      searchItem: {
        ...positionConfig,
        diy: WizTableForm,
      },
    },
    {
      title: '组织',
      name: 'orgIds',
      searchItem: {
        ...organizationConfig,
        diy: WizTableForm,
      }
    },
    {
      title: "任职",
      name: "userIdentityInfos",
      tableItem: {
        render: (text,record) =>{
          let contextList = text && text.split(',').length ? text.split(',') : []
          let content = [];
          let title = ''
          contextList && contextList.length && contextList.map((d,index) => {
            if (index === 0) {
              title = d
            }
            content.push(<p>{d}</p>)
          })
          let _titleView = []
          _titleView.push(title)
          if(contextList && contextList.length > 1){
            _titleView.push(<span className='wiz-press-font-color'> ...</span>)
          }
          return (
            <WizPopover content={content} placement="rightTop">
              {_titleView}
            </WizPopover>
          )
        }
      }
    },
    {
      title: "阅读时间",
      name: "createTime",
      tableItem: {
      }
    },
  ])
  return columns;
}

export const likeRecordColumns =(self) => {
  let columns = []
  columns = columns.concat([
    {
      title: "账号",
      name: "userName",
      searchItem: {},
      tableItem: {}
    },
    {
      title: "姓名",
      name: "fullName",
      searchItem: {},
      tableItem: {}
    },
    {
      title: '岗位',
      name: 'positionIds',
      searchItem: {
        ...positionConfig,
        diy: WizTableForm,
      },
    },
    {
      title: '组织',
      name: 'orgIds',
      searchItem: {
        ...organizationConfig,
        diy: WizTableForm,
      }
    },
    {
      title: "任职",
      name: "userIdentityInfos",
      tableItem: {
        render: (text,record) =>{
          let contextList = text && text.split(',').length ? text.split(',') : []
          let content = [];
          let title = ''
          contextList && contextList.length && contextList.map((d,index) => {
            if (index === 0) {
              title = d
            }
            content.push(<p>{d}</p>)
          })
          let _titleView = []
          _titleView.push(title)
          if(contextList && contextList.length > 1){
            _titleView.push(<span className='wiz-press-font-color'> ...</span>)
          }
          return (
            <WizPopover content={content} placement="rightTop">
              {_titleView}
            </WizPopover>
          )
        }
      }
    },
    {
      title: "点赞时间",
      name: "createTime",
      tableItem: {
      }
    },
  ])
  return columns;
}


export const downLoadRecordColumns =(self) => {
  let columns = []
  columns = columns.concat([
    {
      title: "账号",
      name: "userName",
      searchItem: {},
      tableItem: {}
    },
    {
      title: "姓名",
      name: "fullName",
      searchItem: {},
      tableItem: {}
    },
    {
      title: '岗位',
      name: 'positionIds',
      searchItem: {
        ...positionConfig,
        diy: WizTableForm,
      },
    },
    {
      title: '组织',
      name: 'orgIds',
      searchItem: {
        ...organizationConfig,
        diy: WizTableForm,
      }
    },
    {
      title: "任职",
      name: "userIdentityInfos",
      tableItem: {
        render: (text,record) =>{
          let contextList = text && text.split(',').length ? text.split(',') : []
          let content = [];
          let title = ''
          contextList && contextList.length && contextList.map((d,index) => {
            if (index === 0) {
              title = d
            }
            content.push(<p>{d}</p>)
          })
          let _titleView = []
          _titleView.push(title)
          if(contextList && contextList.length > 1){
            _titleView.push(<span className='wiz-press-font-color'> ...</span>)
          }
          return (
            <WizPopover content={content} placement="rightTop">
              {_titleView}
            </WizPopover>
          )
        }
      }
    },
    {
      title: "下载时间",
      name: "createTime",
      tableItem: {
      }
    },
  ])
  return columns;
}

export const collectRecordColumns =(self) => {
  let columns = []
  columns = columns.concat([
    {
      title: "账号",
      name: "userName",
      searchItem: {},
      tableItem: {}
    },
    {
      title: "姓名",
      name: "fullName",
      searchItem: {},
      tableItem: {}
    },
    {
      title: '岗位',
      name: 'positionIds',
      searchItem: {
        ...positionConfig,
        diy: WizTableForm,
      },
    },
    {
      title: '组织',
      name: 'orgIds',
      searchItem: {
        ...organizationConfig,
        diy: WizTableForm,
      }
    },
    {
      title: "任职",
      name: "userIdentityInfos",
      tableItem: {
        render: (text,record) =>{
          let contextList = text && text.split(',').length ? text.split(',') : []
          let content = [];
          let title = ''
          contextList && contextList.length && contextList.map((d,index) => {
            if (index === 0) {
              title = d
            }
            content.push(<p>{d}</p>)
          })
          let _titleView = []
          _titleView.push(title)
          if(contextList && contextList.length > 1){
            _titleView.push(<span className='wiz-press-font-color'> ...</span>)
          }
          return (
            <WizPopover content={content} placement="rightTop">
              {_titleView}
            </WizPopover>
          )
        }
      }
    },
    {
      title: "收藏时间",
      name: "createTime",
      tableItem: {
      }
    },
  ])
  return columns;
}

export const commentRecordColumns =(self,btnCode) => {
  let columns = []
  columns = columns.concat([
    {
      name: "id",
      key: "id",
      formItem: {
        type: "hidden",
      }
    },
    {
      title: "账号",
      name: "userName",
      searchItem: {},
      tableItem: {}
    },
    {
      title: "姓名",
      name: "fullName",
      searchItem: {},
      tableItem: {}
    },
    {
      title: '岗位',
      name: 'positionIds',
      searchItem: {
        ...positionConfig,
        diy: WizTableForm,
      },
    },
    {
      title: '组织',
      name: 'orgIds',
      searchItem: {
        ...organizationConfig,
        diy: WizTableForm,
      }
    },
    {
      title: "任职",
      name: "userIdentityInfos",
      tableItem: {
        render: (text,record) =>{
          let contextList = text && text.split(',').length ? text.split(',') : []
          let content = [];
          let title = ''
          contextList && contextList.length && contextList.map((d,index) => {
            if (index === 0) {
              title = d
            }
            content.push(<p>{d}</p>)
          })
          let _titleView = []
          _titleView.push(title)
          if(contextList && contextList.length > 1){
            _titleView.push(<span className='wiz-press-font-color'> ...</span>)
          }
          return (
            <WizPopover content={content} placement="rightTop">
              {_titleView}
            </WizPopover>
          )
        }
      }
    },
    {
      title: "评论时间",
      name: "commentTime",
      tableItem: {
      }
    },
    // {
    //   title: "投诉次数",
    //   name: "createTime",
    //   tableItem: {
    //   }
    // },
    {
      title: "评论内容",
      name: "content",
      tableItem: {
        render: (text,record) =>{
            let value_ = text;
            let content = [];
            let _titleView = []
            if (text && text.length && text.length>15) {
              value_ = text.substring(0, 15)
              content.push(<p style={{width:300}} >{text}</p>);
            }else {
              content.push(<p>{text}</p>);
            }
            _titleView.push(value_)
            if(text && text.length && text.length>15){
              _titleView.push(<span className='wiz-press-font-color'> ...</span>)
            }
            return (
              <WizPopover content={content} placement="topRight">
                {_titleView}
              </WizPopover>
            )
        }
      }
    },
    {
      title: "回复人",
      name: "replyFullName",
      tableItem: {
      }
    },
    {
      title: "回复时间",
      name: "replyCommentTime",
      tableItem: {
      }
    },
    {
      title: "回复内容",
      name: "replyContent",
      tableItem: {
      }
    },
    {
      title: "状态",
      name: "stateStr",
      tableItem: {
      }
    },
    {
      title: "操作",
      tableItem: {
        fixed: 'right',
        width: 200,
        render: (text, record) => {
          let {id,state,personId} = record
          //1正常  2置顶  3屏蔽
          let btns = new Map();
          let r = []
          switch(state){
            case 1 :
              btns.set('topOrCancelTop',  <WizButton tooltip="评论置顶"  onClick={e => {self._changeTop(id,state)}}>
                评论置顶
              </WizButton>,)
              btns.set('shieldOrUnshield',<WizButton tooltip="屏蔽" onClick={e => {self._changeScreen(id,state)}}>
                屏蔽
              </WizButton>)
              btns.set('reply',<WizButton tooltip="回复" onClick={e => {self.setState({replyModalVisible:true,commentId:id,replyPerson:personId})}}>
                回复
              </WizButton>)
              break;
              case 2 :
                btns.set('topOrCancelTop', <WizButton tooltip="取消置顶"  onClick={e => {self._changeTop(id,state)}}>
                  取消置顶
                </WizButton>)
                btns.set('shieldOrUnshield',<WizButton tooltip="屏蔽" onClick={e => {self._changeScreen(id,state)}}>
                  屏蔽
                </WizButton>)
                btns.set('reply',<WizButton tooltip="回复" onClick={e => {self.setState({replyModalVisible:true,commentId:id,replyPerson:personId})}}>
                  回复
                </WizButton>)
              break;
              case 3 :
                  btns.set('shieldOrUnshield', <WizButton tooltip="取消屏蔽"  onClick={e => {self._changeScreen(id,state)}}>
                取消屏蔽
              </WizButton>)
              break;
             default:
              break;
          }
          self.btnCode.map(({ code }) => {
            if (btns.has(code)) {
              r.push(btns.get(code))
            }
          })
          return (
            <>
            <WizDataTable.Oper>
              {r}
            </WizDataTable.Oper>
              </>
          )
        }
      }
    }
  ])
  return columns;
}